import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

export const LoadingScreen = props => {
  return (
    <div className={props.loadingStyles}>
      <Skeleton />
      <Skeleton animation={false} />
      <Skeleton animation="wave" />
      <Skeleton />
      <Skeleton animation={false} />
      <Skeleton animation="wave" />
      <Skeleton />
      <Skeleton animation={false} />
      <Skeleton animation="wave" />
      <Skeleton />
      <Skeleton animation={false} />
      <Skeleton animation="wave" />
    </div>
  )
};
